import { BUTTON_TYPES, ButtonComponent as ButtonComponentT } from '@abiglobalhealth/go-types'
import { Button } from '@components/Button'
import { useTranslation } from 'react-i18next'

import { useButtonClick } from '@/hooks/useButtonClick'
import { useGeneralErrors } from '@/hooks/useGeneralErrors'

type ButtonProps = Omit<ButtonComponentT, 'componentType'> & {
  disabled?: boolean
  tabIndex: number
}

export const ButtonComponent = ({ textKey, type = BUTTON_TYPES.PRIMARY, id, buttonAction, disabled, tabIndex }: ButtonProps) => {
  const { t } = useTranslation()
  const { handleButtonClick } = useButtonClick()
  const { clearGeneralErrors } = useGeneralErrors()

  return (
    <Button
      id={id}
      tabIndex={tabIndex}
      disabled={disabled}
      type={type}
      onClick={() => {
        clearGeneralErrors()
        handleButtonClick(buttonAction)
      }}
    >
      {t(textKey)}
    </Button>
  )
}
